import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '../icon/Icon';
import styles from './states.module.css';
export function PausedStrip({ asOf, onRetry }) {
    const what = asOf.trim() === '' ? 'the last answer we got' : `${asOf} data`;
    return (_jsxs("div", { className: styles.paused, role: "status", "aria-live": "polite", children: [_jsx(Icon, { name: "refresh" }), _jsxs("span", { children: ["Live view paused \u2014 showing ", what, ". Retrying\u2026"] }), _jsx("span", { className: styles.pausedSpacer }), _jsx("button", { type: "button", className: styles.retryBtn, onClick: onRetry, children: "Retry now" })] }));
}
//# sourceMappingURL=PausedStrip.js.map